import { createReducer } from '@reduxjs/toolkit'
import { initialState, storeReducerBuilderChange } from '../smart_bps/bps'
import { withRequiredFields } from '../lib/bpsReducerWithRequiredFields'
import { Route } from 'react-router'
import React from 'react'
import { PROJECT_NAME } from "./constants"
import ListView from './list_view'
import ModelView from './model_view'

const initialRequestsState = { ...initialState, search_data: {} }
const baseReducer = createReducer(initialRequestsState, (builder) => {
  storeReducerBuilderChange(builder, PROJECT_NAME)
})
export const reducer = withRequiredFields(PROJECT_NAME, baseReducer)

export const routes = (
    <Route path={ PROJECT_NAME }>
        <Route index element={<ListView/>} />
        <Route path=":object_id" element={<ModelView />} />
    </Route>
)
